export const translationLivechat_en_edit = {
  livechatEditMessage: "Edit",
  livechatEditMessageLabel: "Edit your reply",
  livechatEditMessageSave: "Save",
  livechatEditMessageSaving: "Saving...",
  livechatEditMessageCancel: "Cancel",
  livechatEditMessageFailed: "The reply could not be edited. Try again.",
  livechatEditMessageNoLongerEditable:
    "This reply can no longer be edited. Cancel to keep the sent version.",
  livechatMessageEdited: "edited",
};
